import {
  DashboardOrderDetailsResponse,
  DashboardSystemCurrentTimeResponse,
} from "@/shared/api";
import { OverallProgress } from "./overall-progress";
import { Box, Flex, Skeleton } from "@radix-ui/themes";

type ZoneBasedPredictionProgressProps = {
  data?: DashboardSystemCurrentTimeResponse;
  isLoading: boolean;
  orderDetails?: DashboardOrderDetailsResponse["result"];
};

export function ZoneBasedPredictionProgress({
  data,
  isLoading,
  orderDetails,
}: ZoneBasedPredictionProgressProps) {
  if (isLoading) {
    return (
      <Box mr="2" height="82px">
        <Skeleton
          width="150px"
          height="24px"
          className="rounded-base"
        ></Skeleton>
        <Skeleton height="8px" my="1" className="rounded-full"></Skeleton>
        <Flex justify="between" gap="2">
          <Box className="space-y-1">
            <Skeleton
              height="14px"
              width="76px"
              className="rounded-md"
            ></Skeleton>
            <Skeleton
              height="14px"
              width="120px"
              className="rounded-md"
            ></Skeleton>
          </Box>
          <Flex direction="column" gap="1" align="end">
            <Skeleton
              height="14px"
              width="72px"
              className="rounded-md"
            ></Skeleton>
            <Skeleton
              height="14px"
              width="120px"
              className="rounded-md"
            ></Skeleton>
          </Flex>
        </Flex>
      </Box>
    );
  }

  if (!data) {
    return null;
  }

  return (
    <OverallProgress
      data={data.result}
      finalizedAtTitle="Order time"
      orderTime={orderDetails?.order.time}
      isCompleted={orderDetails?.zone_based_prediction_cart !== null}
    />
  );
}
